<template>
  <b-modal
    ref="modal"
    title="Prospetto redditi e patrimonio immobiliare"
    size="lg"
    class="large"
    centered
    no-close-on-backdrop
  >
    <!-- Visualizza riassunto ultimo prospetto redditi -->
    <!-- prospettoRedditi -- {{prospettoRedditi}}
    istanza -- {{istanza}}
    allegatoCorrente -- {{allegatoCorrente}} -->

    <b-alert
      v-if="prospettoNotExist"
      show
      variant="info"
      class="my-4"
    >
      Non sono presenti prospetti redditi e patrimonio.
    </b-alert>

    <div
      class="box"
      v-else
    >

      <div class="col-12 box-header">Ultimo prospetto aggiornato il {{ prospettoRedditi.dataUltimoAggiornamento ? moment(prospettoRedditi.dataUltimoAggiornamento).format('DD/MM/YYYY') : '' }} </div>
      <div class="row box-body">

        <div
          role="group"
          class="col-12 col-md-3 stack-label"
        >
          <label>Nome</label>
          <b-input
            v-model.trim="prospettoRedditi.nome"
            type="text"
            :formatter="formatUcase"
            size="sm"
          />
          <!-- <b-form-invalid-feedback v-if="!$v.prospettoRedditi.nome.required">Campo obbligatorio</b-form-invalid-feedback> -->
        </div>

        <div
          role="group"
          class="col-12 col-md-3 stack-label"
        >
          <label>Cognome</label>
          <b-input
            v-model.trim="prospettoRedditi.cognome"
            type="text"
            :formatter="formatUcase"
            trim
            size="sm"
          />
          <!-- <b-form-invalid-feedback v-if="!$v.prospettoRedditi.cognome.required">Campo obbligatorio</b-form-invalid-feedback> -->
        </div>

        <div
          role="group"
          class="col-12 col-md-3 stack-label"
        >
          <label>Data di nascita</label>
          <b-input
            v-model="prospettoRedditi.dataNascita"
            type="date"
            size="sm"
          />
          <!-- <b-form-invalid-feedback v-if="!$v.prospettoRedditi.dataNascita.required">Campo obbligatorio</b-form-invalid-feedback> -->
        </div>

        <div
          role="group"
          class="col-12 col-md-3 stack-label"
        >
          <label>Codice Fiscale</label>
          <b-input
            v-model="prospettoRedditi.codiceFiscale"
            type="text"
            :formatter="formatUcase"
            size="sm"
          />
          <!-- <b-form-invalid-feedback v-if="!$v.prospettoRedditi.codiceFiscale.required">Campo obbligatorio</b-form-invalid-feedback> -->
          <!-- <b-form-invalid-feedback v-if="!$v.prospettoRedditi.codiceFiscale.codiceFiscale">Codice fiscale non corretto</b-form-invalid-feedback> -->
        </div>
        <div class="col-12 px-3">
          <div
            class="mb-2 font-weight-bold mt-3 text-muted text-left text-uppercase"
            style="font-size:.9rem; border-bottom:1px solid #ddd"
          >
            Dichiarazione fiscale anno: {{prospettoRedditi.anno}} riferita ai redditi percepiti nell’anno: {{prospettoRedditi.annoFiscale}}
          </div>
          <div
            class="mb-2 font-weight-bold mt-3 text-muted text-left text-uppercase"
            style="font-size:.9rem; border-bottom:1px solid #ddd"
          >
            Riepilogo redditi:
          </div>

          <div
            role="group"
            class="col-12 col-md-12 stack-label"
          >
            <span>Sono presenti {{numeroDichiarazioni}} dichiarazioni per un totale redditi {{totaleRedditi}}.</span>
            <br>
            <span>Nelle dichiarazioni {{disabili ? '' : 'non'}} sono presenti disabili.</span>

          </div>

        </div>
        <div class="col-12 px-3">
          <div
            class="mb-2 font-weight-bold mt-3 text-muted text-left text-uppercase"
            style="font-size:.9rem; border-bottom:1px solid #ddd"
          >
            Riepilogo immobili:
          </div>
          <div
            role="group"
            class="col-12 col-md-12 stack-label"
          >
            <span>Sono presenti {{numeroImmobili}} immobili.</span>
            <br>
            <span>Il totale rendita per i fabbricati è: {{totaleImmobiliRendita}}.</span>
            <br>
            <span>Il totale valore commerciale/reddito dominicale per i le altre tipologie è: {{totaleImmobiliAltri}}.</span>

          </div>
        </div>

      </div>
    </div>

    <template slot="modal-footer">

      <b-button
        variant="success"
        @click="generaDocumento"
        :disabled="isGenerable"
      >
        <font-awesome-icon icon="file-pdf" /> Utilizza documento
      </b-button>

      <b-button
        variant="danger"
        @click="add"
      >
        <font-awesome-icon icon="plus" /> Aggiungi prospetto
      </b-button>

      <b-button
        variant="danger"
        @click="modify"
        :disabled="prospettoNotExist"
      >
        <font-awesome-icon icon="edit" /> Modifica
      </b-button>

      <!-- <b-button
        v-if="idx!==-1"
        variant="danger"
        @click="remove"
      >
        <font-awesome-icon
          icon="trash-alt"
          class="mr-2"
        /> Rimuovi componente
      </b-button> -->

      <b-button
        variant="outline-secondary"
        @click="close"
      >
        <font-awesome-icon
          icon="times"
          class="mr-2"
        /> Annulla
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import moment from 'moment'

// import { required } from 'vuelidate/lib/validators'
// // import cloneDeep from 'lodash/cloneDeep'
// import CodiceFiscale from '../utils/codice-fiscale'
// // import ModelloForm from '@/components/ModelloForm'
// // import numeral from 'numeral'
// // import 'numeral/locales'

const tipoProspettoRedditi = 'AS_PRP'

export default {
  name: 'AllegatiStandardModal',

  data () {
    return {
      item: {},
      rowData: {},
      istanza: {},
      allegatoCorrente: {},
      tipo: tipoProspettoRedditi,
      prospettoRedditi: null,
      familiare: this.emptyFamiliare(),
      idx: -1
    }
  },

  computed: {
    moment () {
      return moment
    },
    disabili () {
      return this.prospettoRedditi.redditi && !!this.prospettoRedditi.redditi.find(reddito => reddito.handicap === 'true')
    },
    numeroDichiarazioni () {
      return this.prospettoRedditi.redditi ? this.prospettoRedditi.redditi.length : 0
    },
    numeroImmobili () {
      return this.prospettoRedditi.immobili ? this.prospettoRedditi.immobili.length : 0
    },
    totaleRedditi () {
      // var i = 0
      let total = 0
      if (this.prospettoRedditi.redditi) {
        this.prospettoRedditi.redditi.forEach(reddito => {
          total += (
            reddito.importoRedditiDipendente * 1 +
            reddito.importoRedditiAutonomo * 1 +
            reddito.importoRedditiAltri * 1 +
            reddito.importoRedditiNonImp * 1)
        })
      }
      return total
    },
    totaleImmobiliRendita () {
      // var i = 0
      let total = 0
      if (this.prospettoRedditi.immobili) {
        this.prospettoRedditi.immobili.forEach(immobile => {
          if (immobile.tipoImmobile === 'F') total += immobile.rendita * 1
        })
      }
      return total
    },
    totaleImmobiliAltri () {
      // var i = 0
      let total = 0
      if (this.prospettoRedditi.immobili) {
        this.prospettoRedditi.immobili.forEach(immobile => {
          if (immobile.tipoImmobile !== 'F') total += immobile.rendita * 1
        })
      }
      return total
    },
    isGenerable () {
      let seGen = false

      // console.log('Immobili ', this.prospettoRedditi ? !!this.prospettoRedditi.immobili : false)
      // console.log('redditi ', this.prospettoRedditi ? !!this.prospettoRedditi.redditi : false)
      // console.log('anno ', this.prospettoRedditi ? !!this.prospettoRedditi.anno : false)
      // console.log('annoFiscale ', this.prospettoRedditi ? !!this.prospettoRedditi.annoFiscale : false)

      // seGen = (this.prospettoRedditi
      //   ? (!!this.prospettoRedditi.immobili && !!this.prospettoRedditi.redditi && !!this.prospettoRedditi.anno && !!this.prospettoRedditi.annoFiscale)
      //   : false)
      seGen = (this.prospettoRedditi
        ? (!!this.prospettoRedditi.redditi && !!this.prospettoRedditi.anno && !!this.prospettoRedditi.annoFiscale)
        : false)

      // console.log('seGen', !seGen)

      return !seGen
    },
    prospettoNotExist () {
      let seProspetto = false

      // console.log('Prospetto redditi ', !!this.prospettoRedditi)

      seProspetto = this.prospettoRedditi ? !!this.prospettoRedditi.id : false
      // console.log('seProspetto', !seProspetto)

      return !seProspetto
    }
  },

  methods: {

    emptyFamiliare () {
      return {
        nome: '',
        cognome: '',
        dataNascita: '',
        codiceFiscale: ''
      }
    },

    async open ({ istanza, rowData }) {
      // this.$v.$reset()
      try {
        this.istanza = istanza
        this.allegatoCorrente = rowData

        this.prospettoRedditi = null

        // console.log('open ({ istanza, rowData })', istanza, rowData)

        await this.$store.dispatch('redditiPatrimonio/loadLastItem', istanza.codiceUtente)

        this.prospettoRedditi = this.$store.state.redditiPatrimonio.item
        // console.log('LoadLast prospetto', this.prospettoRedditi, this.$store.state.redditiPatrimonio)
      } catch (err) {
        // Non riesco ad accedere
        // console.log('Errore APRI allegati standard ', err)
        if (err.code === 2005) {
          // DOcumento non trovato. DOvrebbe essere il primo documento.

        } else {
          throw err
        }
      }

      this.$refs.modal.show()
    },

    close () {
      this.$refs.modal.hide()
    },

    async add () {
      try {
        // console.log('tipoProspettoRedditi', tipoProspettoRedditi, this.tipo)
        let rs = await this.$store.dispatch('redditiPatrimonio/addNew', { tipoDocumento: this.tipo, codiceUib: this.istanza.codiceUib })
        this.close()

        this.$router.push({ name: 'redditiPatrimonio', params: { id: rs.id } })
      } catch (err) {
        this.$ui.showError(err)
        // Se c'è qualsiasi tipo di problema nel caricamento della lista delle dichiarazioni esce comunque.
        this.$router.push({ name: 'home' })
      }

      this.close()
    },

    // Modifica l'ultimo prospetto redditi.
    async modify () {
      try {
        // console.log('tipoProspettoRedditi', tipoProspettoRedditi, this.tipo)
        // let rs = await this.$store.dispatch('redditiPatrimonio/addNew', { tipoDocumento: this.tipo, codiceUib: this.istanza.codiceUib })
        this.close()

        this.$router.push({ name: 'redditiPatrimonio', params: { id: this.prospettoRedditi.id } })
      } catch (err) {
        this.$ui.showError(err)
        // Se c'è qualsiasi tipo di problema nel caricamento della lista delle dichiarazioni esce comunque.
        this.$router.push({ name: 'home' })
      }

      this.close()
    },

    async generaDocumento () {
      // Passare i parametri necessari per individuare il documento da generare ed i dati per la compilazione.

      // console.log('Generazione e download prospetto redditi', this.allegatoCorrente, this.prospettoRedditi.id)

      await this.$store.dispatch('redditiPatrimonio/allegaStandard', { idAllegato: this.prospettoRedditi.id, idIstanza: this.istanza.id })

      // console.log('this.allegatoCorrente', this.prospettoRedditi, this.$store.state.redditiPatrimonio.item)

      this.allegatoCorrente.id = this.$store.state.redditiPatrimonio.item.id
      this.allegatoCorrente.fileName = this.$store.state.redditiPatrimonio.item.fileName

      this.close()

      // impostare l'allegato sulla struttura dati.
      // return `/api/istanze/${this.item.id}/${rowData.id}/download`
    },

    update () {
      this.$set(this.item.nuoviFamiliari, this.idx, this.familiare)
      this.close()
    },

    remove () {
      this.item.nuoviFamiliari.splice(this.idx, 1)
      this.close()
    },
    formatUcase (value, event) {
      return value.toUpperCase()
    }
  }
}

</script>

<style lang="stylus" scoped>
.scrollable {
  max-height: max(20rem, 50vh);
  overflow-y: scroll;
}

.large >>> .modal-lg {
  min-width: 60rem !important;
}
</style>
